import {
  Avatar,
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  IconButton,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";

import { BsBellFill, BsChevronDown } from "react-icons/bs";
import {
  MdClose,
  MdEmail,
  MdKeyboardArrowDown,
  MdMenu,
  MdPhone,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import trainee_icon from "../../img/graduation-university-ceremony-education-graduate-svgrepo-com.svg";
import trainer_icon from "../../img/icons8-training-50.png";
import naptinlogo from "../../img/naptinlogo.png";
import routes from "../../pages/routes";
import LiveWhatsapp from "./LiveWhatsapp";
import {
  destroyUserSession,
  getLocalUserProfile,
} from "../../services/auth.service";
import { IUser } from "../../models/auth.model";
import { HamburgerIcon } from "@chakra-ui/icons";
import trainerRoutes from "../../pages/trainer/routes";
import Adminroutes from "../../pages/admin/routes";

const Header = () => {
  const navigate = useNavigate();
  const router = useNavigate();
  const [display, changeDisplay] = useState("none");
  const [user, setUser] = useState<IUser | null>(null);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    const userProfile = getLocalUserProfile();
    setUser(userProfile);
  }, []);

  const handleLogout = () => {
    destroyUserSession();
    router("/");
    setReload(!reload); // reload page after logout
    changeDisplay("none");
    setUser(null); // change in state to trigger reload
  };

  const handleDashboardNavigation = (category: string) => {
    switch (category) {
      case "Trainer":
        navigate(trainerRoutes.Dashboard);
        break;
      case "Trainee":
        navigate(routes.Dashboard);
        break;
      case "Super Admin":
        navigate(Adminroutes.Dashboard);
        break;
      default:
        navigate("/");
        break;
    }
  };

  const handleProfileNavigation = (category: string) => {
    switch (category) {
      case "Trainer":
        navigate(trainerRoutes.trainerProfile);
        break;
      case "Trainee":
        navigate(routes.Registration);
        break;
      default:
        navigate("/");
        break;
    }
  };

  const ProfileDropdown = () => {
    return (
      <HStack spacing={["4px", "6px"]}>
        <Avatar size="sm" name={user ? user.name : "nil"} />
        <Menu>
          <MenuButton>
            <HStack color="brand.subtitle" fontSize={13}>
              <Flex direction="column" alignItems="flex-end">
                <Text whiteSpace="nowrap" fontWeight={"600"}>
                  {" "}
                  {user?.name}{" "}
                </Text>
              </Flex>
              <MdKeyboardArrowDown />
            </HStack>
          </MenuButton>
          <MenuList fontSize={"13px"} borderRadius={0} color="brand.bodyText">
            <MenuItem
              onClick={() => handleProfileNavigation(user?.category as string)}
              hidden={user?.category==="Super Admin"}
            >
              Update profile
            </MenuItem>
            <MenuItem
              onClick={() =>
                handleDashboardNavigation(user?.category as string)
              }
            >
              Go to dashboard
            </MenuItem>
            <MenuItem onClick={() => handleLogout()}>Logout</MenuItem>
          </MenuList>
        </Menu>
      </HStack>
    );
  };

  return (
    <>
      <Flex
        width="100vw"
        justifyContent={["space-between", "space-between", "none", "none"]}
        bg="white"
        position={["fixed", "fixed", "absolute", "absolute"]}
        zIndex={"1000"}
        pb="10px"
        className="animate__animated animate__fadeInDown"
        marginTop="0px"
        height={"auto"}
      >
        <Box width="100%" display={["none", "none", "block", "block"]}>
          <Flex
            height="45px"
            bg="#FFFFFF"
            borderBottom="0.3px solid"
            borderColor="gray.200"
            direction="row"
            px={14}
            alignItems="center"
            justifyContent="space-between"
          >
            {user == null && (
              <Flex alignItems="center">
                <Box as="span">
                  <Link
                    color="#EC3337"
                    lineHeight={16}
                    fontWeight="600"
                    fontSize="12px"
                    onClick={() => navigate(routes.Login)}
                  >
                    Login
                  </Link>
                </Box>
              </Flex>
            )}

            <Flex
              alignItems="center"
              height="inherit"
              color="#616161"
              fontSize="12px"
              lineHeight="16px"
            >
              <HStack>
                <MdPhone />
                <Text>0704 711 6355 [9:00AM - 5:00PM] |</Text>
              </HStack>
              <HStack ml={2}>
                <MdEmail />
                <Text>support@naptinportal.com</Text>
              </HStack>
            </Flex>
          </Flex>

          <Box px={12}>
            <Flex
              height="45px"
              bg="#FFFFFF"
              direction="row"
              mt="20px"
              alignItems="center"
              justifyContent="space-between"
            >
              <Flex alignItems="center">
                <Link as="span" onClick={() => navigate(routes.LandingPage)}>
                  <Image src={naptinlogo} height="45px" />
                </Link>
              </Flex>
              <HStack
                spacing={["none", "none", "40px", "70px"]}
                color="#616161"
                fontSize={["none", "none", "12px", "14px"]}
              >
                <Link
                  lineHeight={10}
                  fontWeight="600"
                  onClick={() => navigate(routes.FAQ)}
                >
                  FAQ
                </Link>
                <Link
                  lineHeight={10}
                  fontWeight="600"
                  onClick={() => navigate(routes.DashboardAnnouncements)}
                >
                  Announcement
                </Link>
                <Link
                  lineHeight={10}
                  fontWeight="600"
                  onClick={() => navigate(routes.HomeHelpdesk)}
                >
                  Help Desk
                </Link>
              </HStack>

              {user == null && (
                <Menu>
                  <MenuButton
                    as={Button}
                    rightIcon={<BsChevronDown />}
                    colorScheme="red"
                    variant={"outline"}
                    height={38}
                    size="sm"
                    fontSize={13}
                    borderRadius="none"
                  >
                    CREATE ACCOUNT
                  </MenuButton>
                  <MenuList
                    fontSize={"14px"}
                    minWidth="200px"
                    borderRadius="none"
                  >
                    <MenuItem
                      onClick={() => navigate(routes.trainerPreReg)}
                      padding={"0.5rem"}
                    >
                      {" "}
                      <HStack
                        color="brand.bodyText"
                        fontSize={14}
                        alignSelf="center"
                      >
                        <Text>Trainer Account</Text>
                        <Image src={trainer_icon} width="18px" height="18px" />
                      </HStack>
                    </MenuItem>
                    <Divider orientation="horizontal" />
                    <MenuItem
                      onClick={() => navigate(routes.PreRegistration)}
                      padding={"0.5rem"}
                    >
                      <HStack
                        color="brand.bodyText"
                        fontSize={14}
                        alignSelf="center"
                      >
                        <Text>Trainee Account</Text>
                        <Image src={trainee_icon} width="18px" height="18px" />
                      </HStack>
                    </MenuItem>
                  </MenuList>
                </Menu>
              )}
              {user && <ProfileDropdown />}
            </Flex>
          </Box>
        </Box>
        <Flex
          alignItems="center"
          mt="5px"
          display={["flex", "flex", "none", "none"]}
        >
          <Link as="span" onClick={() => navigate(routes.LandingPage)}>
            <Image src={naptinlogo} height="45px" />
          </Link>
        </Flex>
        <Flex display={["flex", "flex", "none", "none"]} mt="5px">
          <IconButton
            bg="#FFFAFA"
            mr={2}
            aria-label="Open Menu"
            size="lg"
            icon={<MdMenu />}
            onClick={() => {
              changeDisplay("flex");
            }}
          />
        </Flex>
        <Flex
          zIndex={"100"}
          w="100vw"
          h="100vh"
          bg="#FFFAFA"
          pos="fixed"
          top="0"
          left="0"
          flexDir="column"
          display={display}
          overflowY="auto"
        >
          <Flex mt="5px" justifyContent="flex-end">
            <IconButton
              bg="#FFFAFA"
              mr={6}
              aria-label="Open Menu"
              size="lg"
              icon={<MdClose />}
              onClick={() => {
                changeDisplay("none");
              }}
            />
          </Flex>
          <Flex flexDir="column" align="center">
            <Box as="span" hidden={user !== null}>
              <Link
                color="#EC3337"
                lineHeight={"16px"}
                fontWeight="600"
                fontSize="12px"
                onClick={() => navigate(routes.Login)}
              >
                Login
              </Link>
            </Box>
            <Link
              lineHeight={10}
              fontWeight="600"
              onClick={() => navigate(routes.FAQ)}
            >
              FAQ
            </Link>
            <Link
              lineHeight={10}
              fontWeight="600"
              onClick={() => navigate(routes.DashboardAnnouncements)}
            >
              Announcement
            </Link>
            <Link
              lineHeight={10}
              fontWeight="600"
              onClick={() => navigate(routes.HomeHelpdesk)}
            >
              Help Desk
            </Link>
            <Link
              lineHeight={10}
              fontWeight="600"
              onClick={() => navigate(routes.PreRegistration)}
              hidden={user !== null}
            >
              Register
            </Link>
            <Link
              lineHeight={10}
              fontWeight="600"
              onClick={() =>
                handleDashboardNavigation(user?.category as string)
              }
            >
              Go to Dashboard
            </Link>
            <Link
              lineHeight={10}
              fontWeight="600"
              onClick={() => handleProfileNavigation(user?.category as string)}
              hidden={user?.category == "Super Admin"}
            >
              Update Profile
            </Link>
            <Link
              lineHeight={10}
              fontWeight="600"
              onClick={() => handleLogout()}
            >
              Logout
            </Link>
          </Flex>
        </Flex>
      </Flex>
      <Box display={["block", "block", "block", "block"]}>
        <LiveWhatsapp />
      </Box>
    </>
  );
};

export default Header;
